export const getTimeSlotIdByMinute = (minute: number) => `timeSlot-${minute}`;
